export const en = {
    title: 'This company does not seem to be using our services yet',
    description: 'If your company wants to start using our service, please',
    contact_us: 'contact us',
};
